<template>
  <div>
    <v-app-bar
      app
      fixed
      flat
      dark
      :color="color"
      class="appBarMobile"
      :extension-height="extensionHeight"
    >
      <slot
        name="backButton"
        v-if="showBackButton"
      >
        <v-btn 
          icon
          class="ml-1"
          width="48"
          height="48"
          @click="resetSelection ? resetSelection() : $router.go(-1)"
          aria-label="go back"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </slot>
      <v-app-bar-nav-icon
        v-if="showNavIcon && !showBackButton && !showSearchFilter"
        @click.stop="$eventHub.$emit('toggleNavigationDrawer')"
        class="ml-2 mr-2"
        aria-label="Toggle navigation menu"
      />
      <router-link
        v-if="showAppIcon & !showSearchFilter"
        to="/"
        style="text-decoration: none; color: inherit;"
        aria-label="Home"
      >
        <v-toolbar-title
          v-if="showAppIcon"
          class="pl-0 pt-2 pr-2"
        >
          <slot name="appIcon" />
        </v-toolbar-title>
      </router-link>
      <slot
        name="title"
        v-if="title && !showSearchFilter"
      >
        <div :style="{'width':showCustomIcon ? '47%':'85%'}">
          <v-toolbar-title
            style="height:56px;"
            class="pl-0 pt-2"
          >
            <span
              class="ml-0 mr-3 mb-4"
              :class="showAppIcon || showBackButton ? 'pl-0': 'pl-2'"
              style="vertical-align: middle; line-height: 40px;"
            >
              <span
                :aria-label="title.replace(/<[^>]*>?/gm, '')"
                role="heading"
                aria-level="1"
                tabindex="0"
                style="font-weight: bold;overflow:ellipses;"
                v-html="title"
              />
            </span>
          </v-toolbar-title>
        </div>
      </slot>
      <v-spacer
        v-if="!showSearchFilter"
        id="appBarSpacer"
      />
      <slot
        name="searchFilter"
        class="searchFilter"
        v-if="showSearchFilter"
      >
        <SearchFilter
          :label="searchLabel"
          :search-icon="searchIcon"
          :title="title"
          :search-dialog="searchDialog"
          :show-input="showSearchInput"
          :type="searchFilterType"
          @hideSearchField="$emit('hideSearchField')"
        />
      </slot>
      <div
        class="mr-0"
        v-if="!showSearchFilter && showEssential"
      >
        <slot name="myEssentials" />
      </div>
      <div
        v-if="!showSearchFilter && showProfile"
        class="mr-4"
      >
        <slot name="profile" />
      </div>
      <div
        v-if="!showSearchFilter && showVerticalMenu"
        class="mr-1"
      >
        <slot name="verticalMenu">
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </slot>
      </div>
      <div
        v-if="!showSearchFilter && showCustomIcon"
        class="flex-nowrap mr-1"
      >
        <slot name="customIcon" />
      </div>
      <template
        v-slot:extension
        v-if="extended"
      >
        <slot
          v-if="extended"
          name="extension"
        />
      </template>
    </v-app-bar>
  </div>
</template>
<script>

  import SearchFilter from "@/components/SearchFilter";

  export default {
    name: "AppBarMobile",
    components:{
       SearchFilter,
    },
    props: {
      showSearchFilter: {
        type: Boolean,
        default: false
      },
      searchFilterType: {
          type: String,
          default:"Essentials"
      },
      color: {
        type: String,
        default: "#0A1F40"
      },
      showNavIcon: {
        type: Boolean,
        default: true
      },
      showFullScreen: {
        type: Boolean,
        default: false
      },
      showBackButton: {
        type: Boolean,
        default: false
      },
      extended: {
        type: Boolean,
        default: false
      },
      title:{
        type:String,
        default:"Your Project Title"
      },
      searchLabel:{
        type:String,
        default:"Search"
      },
      searchDialog: {
        type: Function,
        default:null
      },
      showProfile: {
        type:Boolean,
        default:true
      },
      showEssential:{
        type:Boolean,
        default:true
      },
      showAppIcon: {
        type: Boolean,
        default: false
      },
      showVerticalMenu:{
        type: Boolean,
        default: false
      },
      showCustomIcon: {
        type: Boolean,
        default: false
      },
      resetSelection: {
        type: Function,
        default:null
      },
      showSearchInput:{
        type: Boolean,
        default: false
      },
      extensionHeight: {
        type:String,
        default:null
      },
      searchIcon: {
        type:String,
        default:"search"
      }
    },
    computed: {      

    },
    methods:{
      
    }
  }
</script>

<style>
  ::v-deep #schoolPickerContainer .v-input__control .v-input__slot {
    background-color: #1A3B69;
  }

  .v-toolbar__content, .v-toolbar__extension{
    padding:8px !important; 
  }

  ::v-deep .v-input__slot{
    padding-left:16px !important;
    padding-right:16px !important;
  }
  ::v-deep .v-input__append-inner{
    padding-left:28px !important;
  }

  .searchFilter{
    display: flex;
    flex-grow: 1;
  }
  
</style>